var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"EmailMembers"}},[_c('tip-tap-editor',{attrs:{"editor_type":"default"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }